module.exports = __webpack_public_path__ + "img/01-326x184-gray.d95071ba.jpg";